import React from 'react'
import { Container } from './container'
import auth from '../utils/auth'

const SimplePageHeader = ({ title, noPadding, largePadding }) => {
  const { isOfficial, isVerified } = auth()

  let padding = noPadding ? '' : 'py-8 lg:py-10'
  const role = isOfficial ? 'official' : isVerified ? 'verified' : ''

  if (largePadding) {
    padding = 'py-8 lg:py-20'
  }

  return (
    <Container color="#f5f5f5" className={`page-header ${padding} ${role}`}>
      <div className="flex items-center justify-center text-center">
        <h1 className="text-3xl lg:text-4xl font-bold uppercase">{title}</h1>
      </div>
    </Container>
  )
}

export { SimplePageHeader }
